import axios from 'axios';

export const getAllTemplates = async (params={}) => {
    const url = `/api/v1/user_profile/templates`;
    const res = await axios.get(url, { params });
    return res.data;
};

export async function getTemplate(templateId) {
    const url = `/api/v1/user_profile/templates/${templateId}`;
    const res = await axios.get(url);
    return res.data;
}

export async function createTemplate(params) {
    const url = `/api/v1/user_profile/templates`;
    const res = await axios.post(url, params);
    return res.data;
}

export async function updateTemplate(templateId, params) {
    const url = `/api/v1/user_profile/templates/${templateId}`;
    const res = await axios.patch(url, params);
    return res.data;
}

export async function deleteTemplate(templateId) {
    const url = `/api/v1/user_profile/templates/${templateId}`;
    const res = await axios.delete(url);
    return res.data;
}

//
// Handled by the email message controller
//

export async function createTemplateEmailRendering(templateId, params) {
    const url = `/api/v1/user_profile/templates/${templateId}/email_messages/renderings`;
    const res = await axios.post(url, params);
    return res.data;
}

export const sendTemplateEmail = async (templateId, data) => {
    const url = `/api/v1/user_profile/templates/${templateId}/email_messages`;
    const res = await axios.post(url, data);
    return res.data;
}

export const getEmailMessage = async (emailMessageId) => {
    const url = `/api/v1/user_profile/email_messages/${emailMessageId}`;
    const res = await axios.get(url);
    return res.data;
}

export const resendEmailMessage = async (emailMessageId) => {
    const url = `/api/v1/user_profile/email_messages/${emailMessageId}/resend`;
    const res = await axios.post(url);
    return res.data;
}